import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "./Baseurl/Api.js";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const imageBaseUrl = `${BaseUrl.defaults.baseURL}/categoryproductimage/`;

  useEffect(() => {
    BaseUrl.get("/api/Our_category")
      .then((res) => {
        setCategories(Array.isArray(res.data.data) ? res.data.data : []);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setCategories([]);
      });
  }, []);

  return (
    <>
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap");

        .category-section {
          padding: 60px 0;
          font-family: "Montserrat", sans-serif;
          background: #f7faf8;
        }

        .category-title-block h2 {
          font-size: 34px;
          font-weight: 700;
          color: #185e37;
        }

        .category-title-block p {
          font-size: 16px;
          color: #5f6f65;
        }

        /* Category Card */
        .category-card {
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
            padding: 20px 0; 
        }

        .category-card:hover {
          transform: translateY(-6px);
        }

        .category-image-wrapper {
          width: 160px;
          height: 160px;
          margin: 0 auto;
          border-radius: 50%;
          overflow: hidden;
          box-shadow: 0px 4px 12px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }

        .category-card:hover .category-image-wrapper {
          transform: scale(1.06);
          box-shadow: 0px 6px 20px rgba(0,0,0,0.18);
        }

        .category-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Title Under Image */
        .category-name {
          margin-top: 12px;
          font-size: 16px;
          font-weight: 600;
          color: #1f1f1f;
          transition: color 0.3s ease;
          text-transform: capitalize;
        }

        .category-card:hover .category-name {
          color: #298b31;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .category-image-wrapper {
            width: 110px;
            height: 110px;
          }
          .category-name {
            font-size: 14px;
          }
        }
      `}</style>

      <section className="category-section">
        <div className="container">

          {/* Heading */}
          <div className="row justify-content-center mb-5 text-center category-title-block">
            <div className="col-lg-7">
              <h2>Welcome To Dharaj!</h2>
              <p>You're One Step Closer to Purity</p>
            </div>
          </div>

          {/* Category Slider */}
          {categories.length > 0 ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={25}
              slidesPerView={3}
              autoplay={{ delay: 2500 }}
              pagination={{ clickable: true }}
              breakpoints={{
                480: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                992: { slidesPerView: 5 },
                1200: { slidesPerView: 6 }
              }}
            >
              {categories.map((cat) => (
                <SwiperSlide key={cat.id}>
                  <Link
                    to={`/OurCollection/${cat.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="category-card">
                      <div className="category-image-wrapper">
                        <img
                          src={
                            cat.image
                              ? imageBaseUrl + cat.image
                              : "https://via.placeholder.com/150?text=No+Image"
                          }
                          alt={cat.category}
                          className="category-image"
                          onError={(e) =>
                            (e.target.src =
                              "https://via.placeholder.com/150?text=No+Image")
                          }
                        />
                      </div>

                      <p className="category-name">{cat.category}</p>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <p className="text-center text-muted">Loading categories...</p>
          )}
        </div>
      </section>
    </>
  );
};

export default Category;
